import { listdata, urlpostfix, jsonpostfix } from "@/http/global.js";
import { post, getJSON } from "@/http/http.js";
/*群体祭扫*/
export function getMasssacrifice() {
  let data = {
    key: "SACRIFICER"
  };

  return post(`${urlpostfix}/api/wsjs/census/increase`, data);
}

/*敬献花篮*/
export function getFlower() {
  let data = {
    key: "SACRIFICER"
  };
  return post(`${urlpostfix}/api/wsjs/census/increase`, data);
}



// WEBPACK FOOTER //
// ./src/api/home.js